<template> <!-- OK -->
    <div>
        <NavBar/>
        <UserManagement/>
    </div>
</template>

<script>

    import UserManagement from '../components/UserManagement.vue';
    import NavBar from '../components/NavBar.vue';

    export default {
        name: 'GerenciarUsuarios',
        components: {
            UserManagement,
            NavBar
        }
    }


</script>